import React, { forwardRef } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle, faPlusCircle } from "@fortawesome/free-solid-svg-icons";

const Tab = forwardRef(({ tabId, cmsId, editorClassObj, onClick, selected, title, subtitle, children, width, className }: any, ref: any) => {
    function openTab() {
        onClick(tabId);
    }

    return (
        <>
            <div data-id={cmsId} ref={ref} id={`tab-${tabId}`} style={{ width }} className={classNames("twoup-tab d-flex align-items-center justify-content-center text-center p-6 position-relative", className, editorClassObj, { selected })} onClick={openTab}>
                {selected ? <h2 className="h1 text-serif text-primary">{title}</h2> :
                    <div>
                        <h3 className="text-serif text-primary h2">{title}</h3>
                        <p className="text-muted">{subtitle}</p>
                    </div>
                }
                <div className="icon position-absolute text-primary">{selected ?
                    <FontAwesomeIcon icon={faMinusCircle} /> : <FontAwesomeIcon icon={faPlusCircle} />}
                </div>
            </div>
            <div id={`content-${tabId}`} data-id={cmsId} className={classNames("twoup-tab-content w-100 py-4 px-2 p-md-6 bg-white", className, editorClassObj, { selected })} ref={ref}>
                {children}
            </div>
        </>
    );
});

export default Tab;